import { ButtonSuccessStyle } from '../styles'
import ApproveButtonHook from './ApproveButton.hook'

const ApproveButton = () => {
  const { isHideButton, handleClickApprove } = ApproveButtonHook()

  return !isHideButton ? (
    <ButtonSuccessStyle onClick={handleClickApprove}>อนุมัติ</ButtonSuccessStyle>
  ) : null
}

export default ApproveButton
